/*
Since the user may be using alternative names for their filters we first need
to normalize.
*/
function getAltKey(rootGetters, key) {
  if (key === "lastName") {
    return key;
  }
  const altKey = rootGetters
    .getStoreVar("Category", "page", "text", `${key}AlternativeName`)
    ?.toLowerCase();
  return altKey ?? key;
}

export default {
  getFilterValue: (state, getters, rootState, rootGetters) => (fieldName) => {
    if (rootState.route.name !== "Category") {
      console.warn(
        "You're attempting to get a category filter value on a non-category page. This won't work as this getter needs access to Category store vars."
      );
      return null;
    }
    let value;
    /*
    preselected filters are stored using their alternative name so we have to
    get that first.
     */
    const altKey = getAltKey(rootGetters, fieldName);
    value = state.preselected[altKey];
    if (value === undefined) {
      value = state.lastUsed[fieldName];
    }
    return value;
  },
};
